var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 30,
    viewBox: "0 0 18 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.43125 13.5858C0.650197 14.3668 0.650197 15.6332 1.43125 16.4142L14.1592 29.1421C14.9402 29.9232 16.2065 29.9232 16.9876 29.1421C17.7686 28.3611 17.7686 27.0948 16.9876 26.3137L5.67389 15L16.9876 3.68629C17.7686 2.90524 17.7686 1.63891 16.9876 0.857864C16.2065 0.0768156 14.9402 0.0768156 14.1592 0.857864L1.43125 13.5858ZM4.84546 15V13H2.84546V15L2.84546 17H4.84546V15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPrev);
export default __webpack_public_path__ + "static/media/arrowPrev.ed04bed6.svg";
export { ForwardRef as ReactComponent };